/** 表示言語のブラウザ側（保存・ブラウザの言語・<html lang>・再読み込み）。決め方は domain/language.ts */
import type { StoragePort } from '../application/repository';
import { LANGUAGE_STORAGE_KEY, LANGUAGES, type LanguageId } from '../config/languages';

export function readStoredLanguage(storage: StoragePort | null): string | null {
  try {
    return storage?.getItem(LANGUAGE_STORAGE_KEY) ?? null;
  } catch {
    return null;
  }
}

/** 保存できたか（保存できない環境では、切り替えても再読み込みで戻るので呼び出し側が知らせられるようにする） */
export function storeLanguage(storage: StoragePort | null, id: LanguageId): boolean {
  try {
    if (!storage) return false;
    storage.setItem(LANGUAGE_STORAGE_KEY, id);
    return true;
  } catch {
    return false;
  }
}

export const browserLanguages = (): readonly string[] => (typeof navigator === 'undefined' ? [] : (navigator.languages ?? [navigator.language]));

export function applyHtmlLang(id: LanguageId): void {
  document.documentElement.lang = LANGUAGES[id].htmlLang;
}

export function reloadPage(): void {
  window.location.reload();
}
